import { __extends } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { NavParams, ViewController } from 'ionic-angular';
import { UnitMixModel } from '@apto/models';
import { AppService, UnitMixService } from '@apto/services';
import { BaseSlideModal } from '@apto/shared/modals';
import { EditUnitMixForm } from '@apto/shared/components';
export var UnitMixModalMode = /*@__PURE__*/ (function (UnitMixModalMode) {
    UnitMixModalMode[UnitMixModalMode["LIST"] = 0] = "LIST";
    UnitMixModalMode[UnitMixModalMode["VIEW"] = 1] = "VIEW";
    UnitMixModalMode[UnitMixModalMode["EDIT"] = 2] = "EDIT";
    return UnitMixModalMode;
})({});
var UnitMixModal = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(UnitMixModal, _super);
    function UnitMixModal(appService, navParams, viewController, unitMixService) {
        var _this = _super.call(this, viewController, navParams) || this;
        _this.appService = appService;
        _this.unitMixService = unitMixService;
        _this.modalUrls = new Map([
            [UnitMixModalMode.VIEW, '/:unitMixId']
        ]);
        _this.Modes = UnitMixModalMode;
        _this.records = [];
        _this.selectedRecord = new UnitMixModel();
        _this.mode = _this.navParams.get('mode') || UnitMixModalMode.EDIT;
        _this.selectedRecord = _this.navParams.get('selectedRecord') || new UnitMixModel();
        return _this;
    }
    UnitMixModal.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formResult, unitMix;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formResult = this.editUnitMixForm.save();
                        if (!(formResult && formResult.unitMix))
                            return [3 /*break*/, 2];
                        this.scrollToTop();
                        this.editUnitMixForm.isSaving = true;
                        return [4 /*yield*/, this.unitMixService.upsert(formResult.unitMix)];
                    case 1:
                        unitMix = _a.sent();
                        if (!unitMix) {
                            return [2 /*return*/, this.dismiss()];
                        }
                        this.editUnitMixForm.isSaving = false;
                        this.dismiss();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    UnitMixModal.prototype.delete = function () {
        this.unitMixService.delete([this.selectedRecord._id]);
        this.dismiss();
    };
    return UnitMixModal;
}(BaseSlideModal));
export { UnitMixModal };
